import axios from 'api/axios'
import { ClientProfile } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getClients
 */

export interface GetClientsParams {
	page: number
	size: number
	query?: string
	active?: boolean
	suspended?: boolean
	onBoarding?: boolean
	onBoardingStep?: number
	plan?: 'free' | 'paid'
	platformMode?: 'live' | 'demo'
	archived?: boolean
	fieldFilters?: string
}

/**
 * Type Interface for the Response object you get from getClients request if successful
 */
export interface GetClientsResponse {
	totalCount: number
	records: ClientProfile[]
	totalPages: number
	currentPage: number
}

/**
 * API call to get Clients from the WhatCX Application
 * @param params GetClientsParams - Options for the API call
 * @returns ClientsResponse - Response object returned from the server
 */

export const getClients = async (params: GetClientsParams) => {
	try {
		const { data } = await axios.get<GetClientsResponse>('client', {
			params,
		})

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getClients
